import React, { useEffect, useState } from "react";
import { useFormContext, useListing } from "@/providers";
import DatePicker from "react-datepicker";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { IoSearchOutline } from "react-icons/io5";
import SearchModal from "./SearchModal";
import { LODGING_TYPES } from "@/constants";
import { axiosInstance } from "@/helpers/axios";

export const ListingFilters = () => {
    const { setValue, watch, register } = useFormContext();
    const { getFilteredListings } = useListing();

    const [filters, setFilters] = useState(false);
    const [cities, setCities] = useState([]); // Store all cities from API
    const [filteredCities, setFilteredCities] = useState([]); // Store filtered cities based on user input
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to manage dropdown visibility

    const filtersWatch = watch();

    // Fetch cities from API
    const fetchCities = async () => {
        try {
            const response = await axiosInstance.get('/listing/cities');
            const data = response.data.data; // Assuming the API response has the structure you provided
            setCities(Object.values(data)); // Convert object values to an array of cities
        } catch (error) {
            console.error("Error fetching cities:", error);
        }
    };

    useEffect(() => {
        fetchCities(); // Fetch cities when component mounts
    }, []);

    // Handle input change
    const handleDestinationChange = (e) => {
        const input = e.target.value;
        if (input.length > 0) {
            const filtered = cities.filter(city =>
                city.toLowerCase().includes(input.toLowerCase())
            );
            setFilteredCities(filtered); // Update filtered cities
            setIsDropdownOpen(true); // Open dropdown
        } else {
            setFilteredCities([]); // Clear filtered cities if input is empty
            setIsDropdownOpen(false); // Close dropdown
        }
    };

    // Handle city selection
    const handleCitySelect = (city) => {
        setValue("destination", city); // Set the selected city as the input value
        setFilteredCities([]); // Clear filtered cities
        setIsDropdownOpen(false); // Close dropdown
    };

    const increment = () => {
        setValue("no_of_guest", parseInt(filtersWatch.no_of_guest || 1) + 1);
    };

    const decrement = () => {
        setValue("no_of_guest", Math.max(1, parseInt(filtersWatch.no_of_guest || 1) - 1));
    };

    const handleFilterSubmit = async () => {
        const data = watch();
        await getFilteredListings(data, true);
    };

    return (
        <>
            {/* Destination */}
            <div className="relative main-search-input-item location autocomplete-container">
                {/* Destination Input */}
                <input
                    type="text"
                    placeholder="Destination"
                    className="w-full p-3 border rounded-md autocomplete-input pac-target-input"
                    {...register('destination')}
                    onChange={handleDestinationChange}
                />

                {/* Suggestions Dropdown */}
                {isDropdownOpen && filteredCities.length > 0 && (
                    <ul className="absolute left-0 z-50 w-full h-[230px] overflow-y-scroll mt-1 list-none bg-white border border-gray-200 rounded-md shadow-lg top-full">
                        {filteredCities.map((city, index) => (
                            <li
                                key={index}
                                className="px-4 py-2 cursor-pointer hover:bg-gray-100"
                                onClick={() => handleCitySelect(city)}
                            >
                                {city}
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            {/* Arrival Date */}
            <div className="main-search-input-item">
                <DatePicker
                    selected={filtersWatch.arrival_date}
                    onChange={(date) => setValue("arrival_date", date)}
                    className="border"
                    placeholderText="Arrival Date"
                />
            </div>

            {/* Departure Date */}
            <div className="main-search-input-item">
                <DatePicker
                    selected={filtersWatch.departure_date}
                    onChange={(date) => setValue("departure_date", date)}
                    className="border"
                    placeholderText="Departure Date"
                    minDate={filtersWatch.arrival_date}
                />
            </div>

            {/* Number of Guests */}
            <div className="main-search-input-item input-containers">
                <input
                    type="number"
                    {...register("no_of_guest")}
                    className="input-field"
                    placeholder="Guests"
                    value={filtersWatch.no_of_guest || ""}
                    onChange={(e) => setValue("no_of_guest")}
                />
                <div className="custom-buttons-second">
                    <button type="button" className="increment" onClick={increment}>
                        <IoMdArrowDropup />
                    </button>
                    <button type="button" className="decrement" onClick={decrement}>
                        <IoMdArrowDropdown />
                    </button>
                </div>
            </div>

            {/* Lodging Type */}
            <div className="main-search-input-item">
                <select
                    {...register("lodging_type")}
                    className="nice-select chosen-select no-search-select border !z-[unset]"
                >
                    <option value="">Lodging Type</option>
                    {LODGING_TYPES.map((option, index) => (
                        <option key={index} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>

            {/* Filter Button */}
            <div className="main-search-input-item">
                <button
                    type="button"
                    className="color2-bg mt-0 text-white bg-[#8EC639] rounded-md font-medium w-full h-full"
                    onClick={() => setFilters(!filters)}
                >
                    Filter
                </button>
            </div>

            <div className="main-search-input-item">
                <button
                    type="button"
                    className="color2-bg mt-0 text-white bg-[#8EC639] rounded-md font-medium w-full h-full"
                    onClick={handleFilterSubmit}
                >
                    Search
                </button>
            </div>

            {/* Search Button */}
            {/* <div className="flex items-center justify-center">
                <button
                    type="button"
                    className="color2-bg mt-0 text-white bg-[#8EC639] rounded-md font-medium w-full h-full flex justify-center items-center"
                    onClick={handleFilterSubmit}
                >
                    <IoSearchOutline className="mr-3" />
                    Search
                </button>
            </div> */}

            <SearchModal filters={filters} setFilters={setFilters} />
        </>
    );
};